export function checkLocationFacetFilter(request, nationwideText) {
  // Check if there's a location facetFilter
  const locationFacetFilter =
    request.params.facetFilters &&
    request.params.facetFilters.find(
      (filter) =>
        Array.isArray(filter) && filter[0] && filter[0].startsWith("location:"),
    );

  if (locationFacetFilter && request.params.facetFilters) {
    // Find the existing location filter array
    const locationFacetFilterArray = request.params.facetFilters.find(
      (filter) =>
        Array.isArray(filter) && filter[0] && filter[0].startsWith("location:"),
    );

    if (locationFacetFilterArray) {
      const nationwideEntry = `location:${nationwideText}`;

      // Check if nationwide is already part of the facetFilters array
      if (!locationFacetFilterArray.includes(nationwideEntry)) {
        // Add the new location to the existing array instead of creating a new one
        locationFacetFilterArray.push(nationwideEntry);
      }
    }
  }
}

export function checkLocationFilter(request, nationwideText) {
  // Check if there's a location filter
  const locationFilter =
    request.params.filters && request.params.filters.includes("location:");

  if (locationFilter) {
    // Extract location filter from filters string
    const locationFilterRegex = /location:=\[([^\]]+)]/;
    const locationFilterString =
      request.params.filters.match(locationFilterRegex);

    if (locationFilterString && locationFilterString[1]) {
      // Check if nationwide is already part of the string
      if (!locationFilterString[1].includes(`\`${nationwideText}\``)) {
        // Get the whole location filter string
        const existingLocationFilter = locationFilterString[0];

        // Add nationwideText to the end
        const newFilterValue = existingLocationFilter.replace(
          "]",
          `, \`${nationwideText}\`]`,
        );

        // Replace the old location filter with the new one
        request.params.filters = request.params.filters.replace(
          existingLocationFilter,
          newFilterValue,
        );
      }
    }
  }
}
